module.exports = __webpack_public_path__ + "img/network-error.579309e0.png";